export default __webpack_public_path__ + "static/media/DSC_0526.fab3fe10.JPG";